import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useHeroVideo = () => {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        setLoading(true);
        
        // Get the public URL for the hero video
        const { data } = supabase.storage
          .from('hero-videos')
          .getPublicUrl('hero-background.mp4');
        
        if (data?.publicUrl) {
          setVideoUrl(data.publicUrl);
        }
      } catch (err) {
        setError(err as Error);
        console.error('Error fetching hero video:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideoUrl();
  }, []);

  return { videoUrl, loading, error };
};
